// @ts-nocheck
import React, { useCallback } from 'react';
import {
  ButtonBase,
  styled,
  TextField,
  Stack,
  MenuItem,
  Menu,
  Paper,
  Divider,
} from '@mui/material';
import { Editor } from '@tiptap/react';
import PropTypes from 'prop-types';
import { ReactComponent as Add } from '../../assets/Icons/lucideIcons/plus.svg';
import { ReactComponent as Delete } from '../../assets/Icons/lucideIcons/trash-2.svg';

export const ToolbarBaseButton = styled(ButtonBase, {
  name: 'SolyticsEditorToolbar',
  slot: 'baseButton',
})();

export const ToggleButtonRoot = styled(ToolbarBaseButton, {
  shouldForwardProp: (prop) => prop !== 'isActive',
  name: 'SolyticsEditorToolbar',
  slot: 'toggleButton',
})();

/**
 * @param {import('@mui/material').TextFieldProps} props
 */
const SelectTextField = (props) => <TextField {...props} select />;

export const ToolbarDropdown = styled(SelectTextField, {
  name: 'SolyticsEditorToolbar',
  slot: 'headingDropdown',
})();

/**
 * @param {import('@mui/material').ButtonBaseProps} props
 * @param {import('@tiptap/react').Editor} props.editor
 * @param {import('./useSolyticsEditorToolbar').ToggleAction} props.action
 * @param {() => boolean} handleToggle
 */
export const ToggleButton = ({
  action,
  editor,
  handleToggle,
  children,
  ...props
}) => {
  const onClick = useCallback(
    () => handleToggle(action),
    [action, handleToggle]
  );
  return (
    <ToggleButtonRoot
      className={editor.isActive(action) ? 'is-active' : ''}
      onClick={onClick}
      {...props}
    >
      {children}
    </ToggleButtonRoot>
  );
};
ToggleButton.propTypes = {
  action: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,
  editor: PropTypes.instanceOf(Editor).isRequired,
  children: PropTypes.node.isRequired,
};

export const BubbleMenuContainer = styled(Stack, {
  name: 'BubbleMenuContainer',
  slot: 'root',
})();

export const BubbleMenuButton = styled(ButtonBase, {
  name: 'BubbleMenuButton',
  slot: 'root',
})();

export const ToolbarPaper = styled(Paper, {
  name: 'SolyticsEditorToolbar',
  slot: 'ToolbarPaper',
})();

export const ToolbarMenu = styled(Menu, {
  name: 'SolyticsEditorToolbar',
  slot: 'ToolbarMenu',
})();

export const ToolbarMenuItem = styled(MenuItem, {
  name: 'SolyticsEditorToolbar',
  slot: 'ToolbarMenuItem',
})();

export const AddIcon = () => <Add width={14} height={14} />;
export const DeleteIcon = () => <Delete width={14} height={14} />;

const ToolbarVerticalStyledDivider = styled(Divider, {
  name: 'SolyticsEditorToolbar',
  slot: 'ToolbarVerticalDivider',
})();

export const ToolbarVerticalDivider = () => (
  <ToolbarVerticalStyledDivider flexItem orientation="vertical" />
);
